import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

const WS_URL = import.meta.env.VITE_WS_URL || '/ws';

interface UseWebSocketReturn {
  socket: Socket | null;
  send: (event: string, data?: unknown) => void;
  connected: boolean;
}

export function useWebSocket(): UseWebSocketReturn {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const s = io(WS_URL, {
      path: '/ws',
      transports: ['websocket', 'polling'],
    });

    s.on('connect', () => {
      setConnected(true);
      s.emit('identify', { type: 'player' });
    });

    s.on('disconnect', () => setConnected(false));

    setSocket(s);

    return () => { s.close(); };
  }, []);

  const send = (event: string, data?: unknown) => {
    if (socket?.connected) {
      socket.emit(event, data);
    }
  };

  return { socket, send, connected };
}
